var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 65,
    viewBox: "0 0 92 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PICTO/Image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.158 22.3532L89.0458 47.3952V3.62661H2.95535V46.5513L19.1938 29.6708C19.7067 29.1391 20.6311 29.1391 21.144 29.6708L51.5602 61.2891H89.0458V51.1378C88.8528 51.0691 88.6716 50.9602 88.5202 50.8009L64.1793 25.2848L44.2607 46.1651C43.7414 46.7124 42.8796 46.727 42.3386 46.2008C41.7976 45.6745 41.7822 44.8059 42.3032 44.2604L63.1997 22.3532C63.7117 21.8159 64.646 21.8159 65.158 22.3532ZM2.95535 50.469V61.2894H47.7686L20.1689 32.5973L3.02422 50.4214C3.01387 50.4323 3.00132 50.4393 2.98872 50.4463C2.97706 50.4528 2.96537 50.4593 2.95535 50.469ZM1.59565 0.880859H90.4048C91.1551 0.880859 91.7641 1.49501 91.7641 2.25378V62.6621C91.7641 63.4209 91.1551 64.035 90.4048 64.035H1.59565C0.845305 64.035 0.236328 63.4209 0.236328 62.6621V2.25378C0.236328 1.49501 0.845305 0.880859 1.59565 0.880859ZM47.3593 21.9322C47.3593 26.4738 43.7009 30.1697 39.2033 30.1697C34.7058 30.1697 31.0474 26.4738 31.0474 21.9322C31.0474 17.3906 34.7058 13.6947 39.2033 13.6947C43.7009 13.6947 47.3593 17.3906 47.3593 21.9322Z",
    fill: "#FFFEFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.c06dd8198adc64fa62f6a528a5ce5f18.svg";
export { ForwardRef as ReactComponent };